import { buildComponent } from '#components'

const selectors = {
  mainWidget: 'stamped-main-widget',
  ratingContainers: '.stamped-form-input.stamped-starrating',
  stars: 'a[role="button"][tabindex]'
} as const

const observers = new WeakMap<HTMLElement, MutationObserver>()

const patchStars = (root: HTMLElement) => {
  const ratingContainerElements = root.querySelectorAll<HTMLElement>(selectors.ratingContainers)

  ratingContainerElements.forEach((container) => {
    const starElements = container.querySelectorAll<HTMLAnchorElement>(selectors.stars)

    starElements.forEach((star) => {
      if (star.hasAttribute('onkeydown')) {
        star.removeAttribute('onkeydown')
      }

      if (!star.dataset.glKeyHandled) {
        star.dataset.glKeyHandled = 'true'

        star.addEventListener('keydown', (event) => {
          if (event.key === 'Enter' || event.key === ' ') {
            event.preventDefault()
            star.click()
          }
        })
      }
    })
  })
}

const StampedReviews = buildComponent({
  name: 'stamped-reviews-component',
  onConnected: () => {
    const mainWidget = document.getElementById(selectors.mainWidget)

    if (!mainWidget) return

    patchStars(mainWidget)

    const observer = new MutationObserver(() => {
      patchStars(mainWidget)
    })

    observer.observe(mainWidget, {
      childList: true,
      subtree: true
    })

    observers.set(mainWidget, observer)
  },
  onDisconnected: () => {
    const mainWidget = document.getElementById(selectors.mainWidget)

    if (!mainWidget) return

    observers.get(mainWidget)?.disconnect()
    observers.delete(mainWidget)
  }
})

declare global {
  interface HTMLElementTagNameMap {
    'stamped-reviews-component': HTMLElement
  }
}

export default StampedReviews
